import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import CurrencyBitcoinOutlinedIcon from "@mui/icons-material/CurrencyBitcoinOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { SvgIconProps } from "@mui/material";
import React from "react";
import { FraudTypeEnum, PaymentMethod } from "../types/enums";
import {
  BankDisputeArt,
  BlockchainAnalysisArt,
  ExchangeDisputeArt,
  TrackMasterArt,
  WebIntelligenceArt,
} from "../assets/undraw";

export enum ToolEndpointEnum {
  WEBSITE_FORENSICS_ANALYSIS = "website-forensics-analysis",
  BLOCKCHAIN_ANALYSIS = "blockchain-analysis",
  COMPENDIUM_REPORT = "compendium-reoport",
  WEB_INTELLIGENCE = "web-intelligence",
  BANK_DISPUTE = "bank-dispute",
  TRACK_MASTER = "track-master",
}

export enum CorrespondenceTypes {
  CAFC = "CAFC",
  POLICE = "Police",
  BANK_DISPUTE = "Bank Dispute",
  BANK_DISPUTE_GEORGIA = "Bank Dispute Georgia",
  BANK_DISPUTE_CANADA = "Bank Dispute Canada",
  INTERPOL = "Interpol",
  ISP = "ISP",
  EXCHANGE = "Exchange",
}

export interface Tool {
  hrefMenu: string;
  hrefBackend: string;
  header: string;
  id: string;
  isFormData: boolean;
  tableCoulmns?: string[];
  icon: string;
  ToolNameBackend: string;
  fieldSections?: FieldSection[];
  tableFields?: string[];
  shortExplanation: string;
  toolInformation: string;
  illustration: string;
  isFullPage?: boolean;
}

export interface FieldSection {
  title?: string;
  subtitle?: string;
  type?: any;
  fields: Formfield[];
}

export interface Formfield {
  input?: string;
  header: string;
  type: FormInputType;
  backendHeader: string;
  options?: string[];
  notes?: string;
}

export enum FormInputType {
  TEXT = "text",
  SELECT = "select",
  NUMBER = "number",
  BIGTEXT = "big-text",
  FILE = "file",
  DATE = "date",
  TIME = "time",
}

export enum ToolEnum {
  TRACK_MASTER = "TRACK_MASTER",
  BANK_DISPUTE = "BANK_DISPUTE",
  WEB_INTELLIGENCE = "WEB_INTELLIGENCE",
  COMPENDIUM_REPORT = "COMPENDIUM_REPORT",
  BLOCKCHAIN_ANALYSIS = "BLOCKCHAIN_ANALYSIS",
  WEBSITE_FORENSICS_ANALYSIS = "WEBSITE_FORENSICS_ANALYSIS",
}

export const iconsObject: Record<string, React.ReactElement<SvgIconProps>> = {
  trackMasterProcess: <QueryStatsOutlinedIcon />,
  webIntelligence: <PsychologyOutlinedIcon />,
  blockchainAnalysisProcess: <CurrencyBitcoinOutlinedIcon />,
  bankDispute: <AccountBalanceOutlinedIcon />,
  exchangeDispute: <SwapHorizIcon />,
};

export const toolIllustration = {
  trackMasterArt: TrackMasterArt,
  webIntelligenceArt: WebIntelligenceArt,
  blockchainAnalysisArt: BlockchainAnalysisArt,
  bankDisputeArt: BankDisputeArt,
  exchangeDisputeArt: ExchangeDisputeArt,
};

export const tools: Tool[] = [
  {
    header: "Track Master",
    hrefMenu: "tool/track-master",
    // icon: <QuaryStatsIcon color={colors.colorBlue} />,
    icon: "trackMasterProcess",
    id: "track-master",
    hrefBackend: "trackMasterProcess",
    isFormData: false,
    illustration: toolIllustration.trackMasterArt,
    ToolNameBackend: "TRACK_MASTER",
    shortExplanation:
      "Generate a custom link to send to suspected scammers. When they click, we capture valuable technical details to help identify and report them without revealing your own information.",
    toolInformation:
      "Trackmaster is designed to provide enhanced cybersecurity protection by precisely identifying potential scammer locations. Through sophisticated analysis and tracking techniques, Trackmaster helps users pinpoint the geographic origin of suspicious activities, enabling proactive measures to safeguard against online threats. This tool empowers individuals and organizations to stay vigilant and take proactive steps to protect their digital assets and sensitive information from malicious actors.",
    fieldSections: [
      {
        fields: [
          {
            header: "Type of fraud",
            type: FormInputType.SELECT,
            // options: ["Romance", "Investments", "Phishing", "Else"],
            options: [
              FraudTypeEnum.CRYPTO,
              FraudTypeEnum.INVESTMENTS,
              FraudTypeEnum.JOB,
              FraudTypeEnum.PHISHING,
              FraudTypeEnum.ROMANCE,
              FraudTypeEnum.ELSE,
            ],
            backendHeader: "fraudType",
          },
          {
            header: "Fraud URL",
            type: FormInputType.TEXT,
            backendHeader: "fraudUrl",
          },
          {
            header: "Communication Channels",
            type: FormInputType.TEXT,
            notes: "Example: Whatsapp, Telegram, Email",
            backendHeader: "communicationChannel",
          },
          {
            header: "Notes",
            type: FormInputType.BIGTEXT,
            backendHeader: "notes",
            notes:
              "please include information about the scammers, including email addresses, phone numbers, and the general story.",
          },
        ],
      },
    ],
  },
  {
    header: "Web Intelligence",
    hrefMenu: "tool/web-intelligence",
    // icon: <NetworkIntellagenceIcon color={colors.colorBlue} />,
    icon: "webIntelligence",
    id: "web-intelligence",
    illustration: toolIllustration.webIntelligenceArt,
    hrefBackend: "webIntelligence",
    shortExplanation: "Analyzing online data",
    toolInformation:
      "Web intelligence involves analyzing online data to extract insights. Techniques include web scraping, social media monitoring, and data mining. This data reveals trends, risks, and opportunities, aiding informed decisions and cybersecurity.",
    isFormData: true,
    ToolNameBackend: "WEB_INTELLIGENCE",
    fieldSections: [
      {
        fields: [
          {
            header: "Website Name",
            type: FormInputType.TEXT,
            backendHeader: "websiteName",
          },
          {
            header: "Website URL",
            type: FormInputType.TEXT,
            backendHeader: "websiteUrl",
          },
          {
            header: "Fraud Type",
            type: FormInputType.SELECT,
            options: [
              FraudTypeEnum.CRYPTO,
              FraudTypeEnum.INVESTMENTS,
              FraudTypeEnum.PHISHING,
              FraudTypeEnum.JOB,
              FraudTypeEnum.ROMANCE,
              FraudTypeEnum.ELSE,
            ],
            backendHeader: "fraudType",
          },
          {
            header: "Description",
            type: FormInputType.BIGTEXT,
            backendHeader: "description",
          },
          {
            header: "Amount lost",
            type: FormInputType.NUMBER,
            backendHeader: "amountLost",
          },
          {
            header: "Country",
            type: FormInputType.TEXT,
            backendHeader: "country",
          },
        ],
      },
    ],
  },
  {
    header: "Blockchain Analysis",
    hrefMenu: "tool/blockchain-analysis",
    // icon: <CurrencyBitcoinIcon color={colors.colorBlue} />,
    icon: "blockchainAnalysisProcess",
    id: "blockchain-analysis",
    illustration: toolIllustration.blockchainAnalysisArt,
    hrefBackend: "blockchainAnalysisProductRequest",
    isFormData: false,
    shortExplanation: "Trace the flow of funds",
    toolInformation:
      "Blockchain Analysis is a vital tool in the fight against cryptocurrency scams, offering crucial insights into the movement and destination of digital assets. By examining the blockchain, we can trace the flow of funds from the victim's wallet to the scammer's address, providing invaluable evidence of fraudulent activity. This process not only helps to identify the perpetrators but also aids in building a case for recovery efforts. Understanding the path of stolen cryptocurrency is essential for victims seeking restitution, as it enables them to pursue legal avenues and engage with relevant authorities. With Blockchain Analysis, victims can gain clarity on the disposition of their funds and take proactive steps towards recovering their assets.",
    ToolNameBackend: "BLOCKCHAIN_ANALYSIS",
    fieldSections: [
      {
        fields: [
          {
            header: "Crypto Network",
            type: FormInputType.SELECT,
            options: ["ETH", "BTC", "TRON"],
            backendHeader: "cryptoNetwork",
          },
          {
            header: "Crypto Wallet",
            type: FormInputType.TEXT,
            backendHeader: "cryptoWallet",
          },
          {
            header: "Crypto Amount",
            type: FormInputType.NUMBER,
            backendHeader: "cryptoAmount",
          },
          {
            header: "Fiat Amount",
            type: FormInputType.NUMBER,
            backendHeader: "fiatAmount",
          },
          {
            header: "Crypto Transaction",
            type: FormInputType.TEXT,
            backendHeader: "cryptoTransaction",
          },
          {
            header: "Exchange that was used in order to send the funds",
            type: FormInputType.TEXT,
            backendHeader: "exchangeUsed",
          },
          {
            header: "Transuction Date",
            type: FormInputType.DATE,
            backendHeader: "transactionDate",
          },
        ],
      },
    ],
  },
  {
    header: "Bank Dispute",
    hrefMenu: "tool/bank-dispute",
    // icon: <MonitoringIcon color={colors.colorBlue} />,
    icon: "bankDispute",
    id: "bank-dispute",
    illustration: toolIllustration.bankDisputeArt,
    hrefBackend: "bankDispute",
    shortExplanation: "Disputing fraudulent bank transactions",
    toolInformation:
      "We guide clients in disputing fraudulent bank transactions to reclaim lost funds. Our team compiles evidence and advises on the appropriate course of action with banks, aiming for clients' rights and enhance refund success rates.",
    isFormData: true,
    ToolNameBackend: "BANK_DISPUTE",
    fieldSections: [
      {
        fields: [
          {
            header: "Amount Lost:",
            type: FormInputType.NUMBER,
            backendHeader: "amountLost",
          },
          {
            header: "Transaction Date:",
            type: FormInputType.DATE,
            backendHeader: "transactionDate",
          },
          {
            header: "What bank was used for the transuction:",
            type: FormInputType.TEXT,
            backendHeader: "transactionsBankUsed",
          },
          {
            header: "Payment Method:",
            type: FormInputType.SELECT,
            backendHeader: "paymentMethod",
            options: [
              PaymentMethod.CARD,
              PaymentMethod.CRYPTO,
              PaymentMethod.WIRE,
              PaymentMethod.ELSE,
            ],
          },
          {
            header: "Bank Statement:",
            type: FormInputType.FILE,
            backendHeader: "bankStatement",
          },
        ],
      },
    ],
  },
  {
    header: "Exchange Dispute",
    hrefMenu: "tool/exchange-dispute",
    // icon: <MonitoringIcon color={colors.colorBlue} />,
    icon: "exchangeDispute",
    id: "exchange-dispute",
    illustration: toolIllustration.exchangeDisputeArt,
    hrefBackend: "exchangeDispute",
    shortExplanation: "Disputing transactions with cryptocurrency exchanges",
    toolInformation:
      "We guide clients in disputing transactions with cryptocurrency exchanges to recover lost funds. Our team compiles evidence and advises on the appropriate course of action with exchanges, aiming to empower clients to navigate the dispute process effectively.",
    isFormData: true,
    ToolNameBackend: "EXCHANGE_DISPUTE",
    fieldSections: [
      {
        fields: [
          {
            header: "Amount Lost:",
            type: FormInputType.NUMBER,
            backendHeader: "amountLost",
          },
          {
            header: "Transaction Date:",
            type: FormInputType.DATE,
            backendHeader: "transactionDate",
          },
          {
            header: "Exchange used to carry out the transactions:",
            type: FormInputType.TEXT,
            backendHeader: "transactionsExchangeUsed",
          },
          {
            header: "Payment Method:",
            type: FormInputType.SELECT,
            backendHeader: "paymentMethod",
            options: [
              PaymentMethod.CARD,
              PaymentMethod.CRYPTO,
              PaymentMethod.WIRE,
              PaymentMethod.ELSE,
            ],
          },
          {
            header: "Browse:",
            type: FormInputType.FILE,
            backendHeader: "cryptoTransfer",
            notes: "upload a screenshot of the crypto transfer",
          },
        ],
      },
    ],
  },
  {
    header: "Correspondence",
    hrefMenu: "tool/exchange-dispute",
    icon: "correspondence",
    id: "correspondence",
    illustration: toolIllustration.exchangeDisputeArt,
    ToolNameBackend: "CORRESPONDENCE",
    hrefBackend: "correspondence",
    shortExplanation: "Disputing transactions with cryptocurrency exchanges",
    toolInformation:
      "Use this section to easily report scammers to their internet or service providers. Fill out the form with key details such as the scammer's identity, the nature of the scam, and any supporting evidence you have. The system will then generate a formal message to be sent directly to the relevant provider, ensuring they take swift action to address the fraudulent activity and protect other users from harm. Secure your online safety by reporting scams promptly and efficiently.",
    isFormData: false,
    isFullPage: true,
    fieldSections: [
      {
        type: CorrespondenceTypes.CAFC,
        fields: [
          {
            header: "Type of fraud",
            type: FormInputType.TEXT,
            backendHeader: "typeOfFraud",
          },
          {
            header: "Authority",
            type: FormInputType.TEXT,
            backendHeader: "authority",
          },
          {
            header: "Collaborate name",
            type: FormInputType.TEXT,
            backendHeader: "collaborateName",
          },
          {
            header: "Ip address",
            type: FormInputType.TEXT,
            backendHeader: "ipAddress",
          },
          {
            header: "Name",
            type: FormInputType.TEXT,
            backendHeader: "name",
          },
          {
            header: "Date",
            type: FormInputType.DATE,
            backendHeader: "date",
          },
          {
            header: "Amount in CAD",
            type: FormInputType.NUMBER,
            backendHeader: "amountInCad",
          },
          {
            header: "Description",
            type: FormInputType.BIGTEXT,
            backendHeader: "description",
          },
          {
            header: "Specific Details",
            type: FormInputType.TEXT,
            backendHeader: "specificDetails",
          },
          {
            header: "Email",
            type: FormInputType.TEXT,
            backendHeader: "email",
          },
          {
            header: "Phone",
            type: FormInputType.TEXT,
            backendHeader: "phone",
          },
        ],
      },
      {
        type: CorrespondenceTypes.POLICE,
        fields: [
          {
            header: "Law enforcement agency name",
            type: FormInputType.TEXT,
            backendHeader: "lawEnforcementAgencyName",
          },
          {
            header: "Department name",
            type: FormInputType.TEXT,
            backendHeader: "departmentName",
          },
          {
            header: "Office or Unit address",
            type: FormInputType.TEXT,
            backendHeader: "office",
          },
          {
            header: "City",
            type: FormInputType.TEXT,
            backendHeader: "city",
          },
          {
            header: "Country",
            type: FormInputType.TEXT,
            backendHeader: "country",
          },
          {
            header: "Name",
            type: FormInputType.TEXT,
            backendHeader: "name",
          },
          {
            header: "Date of incident",
            type: FormInputType.DATE,
            backendHeader: "date",
          },
          {
            header: "Type of crime",
            type: FormInputType.TEXT,
            backendHeader: "typeOfCrime",
          },
          {
            header: "Amount lost",
            type: FormInputType.NUMBER,
            backendHeader: "amountLost",
          },
          {
            header: "Exchange platform",
            type: FormInputType.TEXT,
            backendHeader: "exchangePlatform",
          },
          {
            header: "Wallet address",
            type: FormInputType.TEXT,
            backendHeader: "walletAddress",
          },
          {
            header: "Description",
            type: FormInputType.BIGTEXT,
            backendHeader: "description",
          },
          {
            header: "Actions taken",
            type: FormInputType.TEXT,
            backendHeader: "actionsTaken",
          },

          {
            header: "Phone",
            type: FormInputType.TEXT,
            backendHeader: "phone",
          },
          {
            header: "Email",
            type: FormInputType.TEXT,
            backendHeader: "email",
          },
          {
            header: "Address",
            type: FormInputType.TEXT,
            backendHeader: "address",
          },
        ],
      },
      {
        type: CorrespondenceTypes.ISP,
        fields: [
          {
            header: "ISP name",
            type: FormInputType.TEXT,
            backendHeader: "ispName",
          },
          {
            header: "Fraud date",
            type: FormInputType.DATE,
            backendHeader: "date",
          },
          {
            header: "IP address",
            type: FormInputType.TEXT,
            backendHeader: "ipAddress",
          },
          {
            header: "Description",
            type: FormInputType.BIGTEXT,
            backendHeader: "description",
          },
          {
            header: "Phone number",
            type: FormInputType.TEXT,
            backendHeader: "phone",
          },
          {
            header: "Name",
            type: FormInputType.TEXT,
            backendHeader: "name",
          },
          {
            header: "Email",
            type: FormInputType.TEXT,
            backendHeader: "email",
          },
        ],
      },
      {
        type: CorrespondenceTypes.BANK_DISPUTE,
        fields: [
          {
            header: "Bank address",
            type: FormInputType.TEXT,
            backendHeader: "bankAddress",
          },
          {
            header: "Specific details",
            type: FormInputType.TEXT,
            backendHeader: "specificDetails",
          },
          {
            header: "Name",
            type: FormInputType.TEXT,
            backendHeader: "name",
          },
          {
            header: "Email",
            type: FormInputType.TEXT,
            backendHeader: "email",
          },
          {
            header: "Phone",
            type: FormInputType.TEXT,
            backendHeader: "phone",
          },
          {
            header: "Bank name",
            type: FormInputType.TEXT,
            backendHeader: "bankName",
          },
          {
            header: "Description",
            type: FormInputType.BIGTEXT,
            backendHeader: "description",
          },
          {
            header: "Specific Details",
            type: FormInputType.TEXT,
            backendHeader: "specificDetails",
          },
          {
            header: "Amount lost",
            type: FormInputType.NUMBER,
            backendHeader: "amountLost",
          },
        ],
      },
      {
        type: CorrespondenceTypes.BANK_DISPUTE_CANADA,
        fields: [
          {
            header: "Bank address",
            type: FormInputType.TEXT,
            backendHeader: "bankAddress",
          },
          {
            header: "Bank name",
            type: FormInputType.TEXT,
            backendHeader: "bankName",
          },
          {
            header: "Amount lost",
            type: FormInputType.NUMBER,
            backendHeader: "amountLost",
          },
          {
            header: "Name",
            type: FormInputType.TEXT,
            backendHeader: "name",
          },
          {
            header: "Email",
            type: FormInputType.TEXT,
            backendHeader: "email",
          },
          {
            header: "Phone",
            type: FormInputType.TEXT,
            backendHeader: "phone",
          },
          {
            header: "Description",
            type: FormInputType.BIGTEXT,
            backendHeader: "description",
          },
          {
            header: "Receipt number",
            type: FormInputType.TEXT,
            backendHeader: "receiptNumber",
          },
          {
            header: "Time",
            type: FormInputType.TIME,
            backendHeader: "time",
          },
          {
            header: "Price",
            type: FormInputType.NUMBER,
            backendHeader: "price",
          },
          {
            header: "AdditionalFee",
            type: FormInputType.TEXT,
            backendHeader: "additionalFee",
          },
          {
            header: "Crypto",
            type: FormInputType.NUMBER,
            backendHeader: "crypto",
          },
          {
            header: "Bitcoin address",
            type: FormInputType.TEXT,
            backendHeader: "bitcoinAddress",
          },
          {
            header: "Rate",
            type: FormInputType.TEXT,
            backendHeader: "rate",
          },
          {
            header: "Tx Id",
            type: FormInputType.TEXT,
            backendHeader: "txId",
          },
        ],
      },
      {
        type: CorrespondenceTypes.BANK_DISPUTE_GEORGIA,
        fields: [
          {
            header: "Bank address",
            type: FormInputType.TEXT,
            backendHeader: "bankAddress",
          },
          {
            header: "Bank name",
            type: FormInputType.TEXT,
            backendHeader: "bankName",
          },
          {
            header: "Name",
            type: FormInputType.TEXT,
            backendHeader: "name",
          },
          {
            header: "Description",
            type: FormInputType.BIGTEXT,
            backendHeader: "description",
          },
          {
            header: "Specific details",
            type: FormInputType.TEXT,
            backendHeader: "specificDetails",
          },
          {
            header: "Amount lost",
            type: FormInputType.NUMBER,
            backendHeader: "amountLost",
          },
        ],
      },
      {
        type: CorrespondenceTypes.INTERPOL,
        fields: [
          {
            header: "Address",
            type: FormInputType.TEXT,
            backendHeader: "address",
          },
          {
            header: "Actions taken",
            type: FormInputType.TEXT,
            backendHeader: "actionsTaken",
          },
          {
            header: "Amount lost",
            type: FormInputType.NUMBER,
            backendHeader: "amountLost",
          },
          {
            header: "Type of crime",
            type: FormInputType.TEXT,
            backendHeader: "typeOfCrime",
          },
          {
            header: "Date of incident",
            type: FormInputType.DATE,
            backendHeader: "date",
          },
          {
            header: "Name",
            type: FormInputType.TEXT,
            backendHeader: "name",
          },
          {
            header: "ISP/Exchange",
            type: FormInputType.TEXT,
            backendHeader: "ispOrExchange",
          },
          {
            header: "Description",
            type: FormInputType.BIGTEXT,
            backendHeader: "description",
          },
          {
            header: "Specific details",
            type: FormInputType.TEXT,
            backendHeader: "specificDetails",
          },
          {
            header: "Country",
            type: FormInputType.TEXT,
            backendHeader: "country",
          },
          {
            header: "IP address",
            type: FormInputType.TEXT,
            backendHeader: "ipAddress",
          },
          {
            header: "Suspected wallet address",
            type: FormInputType.TEXT,
            backendHeader: "suspectedWalletAddress",
          },
          {
            header: "Email",
            type: FormInputType.TEXT,
            backendHeader: "email",
          },
          {
            header: "Phone",
            type: FormInputType.TEXT,
            backendHeader: "phone",
          },
        ],
      },
      {
        type: CorrespondenceTypes.EXCHANGE,
        fields: [
          {
            header: "Exchange service",
            type: FormInputType.TEXT,
            backendHeader: "exchangeService",
          },
          {
            header: "Wallet address",
            type: FormInputType.TEXT,
            backendHeader: "walletAddress",
          },
          {
            header: "Description",
            type: FormInputType.BIGTEXT,
            backendHeader: "description",
          },
          {
            header: "Amount lost",
            type: FormInputType.NUMBER,
            backendHeader: "amountLost",
          },
          {
            header: "Name",
            type: FormInputType.TEXT,
            backendHeader: "name",
          },

          {
            header: "Email",
            type: FormInputType.TEXT,
            backendHeader: "email",
          },
          {
            header: "Phone",
            type: FormInputType.TEXT,
            backendHeader: "phone",
          },
        ],
      },
    ],
  },
];
